/**
 * Created by shubham on 8/5/18.
 */

import { Routes, RouterModule }  from '@angular/router';
import { AdminManagementComponent } from './adminManagement.component';
import { AdminListComponent } from './adminList/adminList.component';
import { AddAdminComponent } from './addAdmin/addAdmin.component';
import { ViewAdminComponent } from './viewAdmin/viewAdmin.component';

export const AdminManagementRoutes: Routes = [
    {
        path: '',
        component: AdminManagementComponent,
        children: [
            { path: '', redirectTo: '/app/profile', pathMatch: 'full' },
            { path: 'list', component: AdminListComponent },
            { path: 'add', component: AddAdminComponent },
            { path: 'view/:id', component: ViewAdminComponent },
        ]
    }
];

export const AdminManagementRoutingModule = RouterModule.forChild(AdminManagementRoutes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/adminManagement/adminManagement-routing.module.ts